import { useRef, useState } from "react";

import api from "@helpers/api";

export default function useAdminPostManage({ modalRef }) {
    const callbackRef = useRef();

    const [open, setOpen] = useState(false);
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(false);

    modalRef.current = {
        open(targetPost, onChange) {
            setPost(targetPost || null);
            callbackRef.current = onChange;
            setOpen(true);
        },
    };

    function handleClose() {
        setOpen(false);
    }

    function notifyChange() {
        callbackRef.current?.();
    }

    async function handleAddPoints(points) {
        if (!post?.id) return false;

        if (points < 1 || points > 10000) {
            window.setSnackbar(
                "Adicione uma quantidade de pontos entre 1 e 10000"
            );
            return false;
        }

        setLoading(true);
        try {
            const { data } = await api.post(
                `community/group/post/${post.id}/points`,
                { points }
            );

            if (data.success) {
                window.setSnackbar("Pontos adicionados com sucesso");
                setOpen(false);
                notifyChange();
                return true;
            }

            window.setSnackbar(
                "Houve um erro ao adicionar os pontos deste post, tente novamente em alguns minutos"
            );
        } catch (e) {
            window.setSnackbar(
                "Houve um erro ao adicionar os pondos deste post, tente novamente mais tarde"
            );
        } finally {
            setLoading(false);
        }

        return false;
    }

    async function handleDeducePoints(points) {
        if (!post?.id) return false;

        const available = post?.insights?.points || 0;

        if (points < 1 || points > available) {
            window.setSnackbar(
                `Deduza uma quantidade de pontos entre 1 e ${available}`
            );
            return false;
        }

        setLoading(true);
        try {
            const { data } = await api.delete(
                `community/group/post/${post.id}/points`,
                { points }
            );

            if (data.success) {
                window.setSnackbar("Pontos removidos com sucesso");
                setOpen(false);
                notifyChange();
                return true;
            }

            window.setSnackbar(
                "Houve um erro ao deduzir os pontos deste post, tente novamente em alguns minutos"
            );
        } catch (e) {
            window.setSnackbar(
                "Houve um erro ao deduzir os pondos deste post, tente novamente mais tarde"
            );
        } finally {
            setLoading(false);
        }

        return false;
    }

    function handleDeletePost() {
        if (!post?.id) return;

        window.openConfirm({
            title: "Apagar post",
            headline: "Atenção!",
            subtitle: "Você realmente deseja apagar permanentemente este post?",
            buttons: [
                {
                    text: "Apagar permanentemente",
                    onClick: executeDelete,
                    variant: "contained",
                    className: "",
                    color: "error",
                },
                {
                    text: "Manter post",
                    variant: "text",
                },
            ],
        });

        async function executeDelete() {
            try {
                const { data } = await api.delete(
                    `community/group/post/${post.id}`
                );

                if (data.success) {
                    window.setSnackbar("Post deletado com sucesso");
                    setOpen(false);
                    notifyChange();
                } else {
                    window.setSnackbar(
                        "Houve um erro ao apagar este post, tente novamente em alguns minutos"
                    );
                }
            } catch (e) {
                window.setSnackbar(
                    "Houve um erro ao apagar este post, tente novamente mais tarde"
                );
            }
        }
    }

    return {
        open,
        post,
        loading,
        handleClose,
        handleAddPoints,
        handleDeducePoints,
        handleDeletePost,
    };
}
